<base-index-page 
    [config]="baseIndexPageConfig"
    [service]="requestsService"
    [idKey]="'requestId'"
></base-index-page>